import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Card, CardMedia, CardContent } from "@mui/material";
import styled from 'styled-components';
import PocketBase from 'pocketbase';

const pb = new PocketBase(process.env.REACT_APP_POCKETBASE_URL);

const ProfileYouTube = ( {teacherId , recordUrl} ) => {
  const [videos, setVideos] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredVideos, setFilteredVideos] = useState([]);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await pb.collection('Class_Recordings').getFullList();
        setVideos(response);
        setFilteredVideos(response);
      } catch (error) {
        console.error('Failed to load videos. Displaying sample data.');
      }
    };
    fetchVideos();
  }, [teacherId]);

  useEffect(() => {
    const results = videos.filter(video =>
      video.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredVideos(results.slice(0, 6));
  }, [searchTerm, videos]);

  const formatYouTubeUrl = (url) => {
    const urlObj = new URL(url);
    const videoId = urlObj.searchParams.get("v") || urlObj.pathname.split("/").pop();
    return `https://www.youtube.com/embed/${videoId}`;
  };

  return (
    <Box sx={{ 
      p: { xs: 2, sm: 3 },
      maxWidth: 1200,
      mx: "auto",
      backgroundColor: "background.default"
    }}>
    <Box sx={{ 
      width: '100%',
      height: '100px',
      borderRadius: '2px',
      overflow: 'hidden'
    }}>
      <img 
        src={recordUrl}
        alt="" 
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '2%',
        }} 
      />
    </Box>
      <SearchBar
        fullWidth
        variant="outlined"
        placeholder="Search Videos"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{ mb: 3 }}
      />
      <Grid container spacing={3}>
        {filteredVideos.map((video) => (
          <Grid item xs={12} sm={12} md={4} key={video.id}>
            <Card sx={{ 
              borderRadius: "16px",
              boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
              transition: "transform 0.2s, box-shadow 0.2s",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 12px 24px rgba(0,0,0,0.15)"
              }
            }}>
              <CardMedia
                component="iframe"
                height="200"
                src={formatYouTubeUrl(video.link)}
                title={video.name}
                sx={{
                  border: "none",
                  borderRadius: "16px 16px 0 0",
                  boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.05)"
                }}
              />
              <CardContent sx={{ 
                backgroundColor: "background.paper",
                borderRadius: "0 0 16px 16px"
              }}>
                <Typography variant="h6" sx={{ 
                  fontWeight: 600,
                  mb: 0.5,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical"
                }}>
                  {video.name}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ProfileYouTube;

const SearchBar = styled.input`
  width: 100%;
  padding: 8px 12px;
  margin: 10px 0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;

  &:focus {
    border-color: #2196f3;
    outline: none;
  }
`;